var tabsContainers = document.querySelectorAll('.tabs-container');

tabsContainers.forEach(tabContainer => {
    let tabs = tabContainer.querySelectorAll('.tab');
    let indicator = tabContainer.querySelector('.indicator');

    indicator.style.width = `${80 / tabs.length}%`;
    indicator.style.marginLeft = `${10 / tabs.length}%`;
    indicator.style.left = 0;

    let tabWidth = 100 / tabs.length;

    tabs.forEach(tab => {
        tab.addEventListener('click', () => { 
            activateTab(tab);
            positionInditicator(indicator, tabWidth, tab.dataset.tabId);
        })
    });
});

/**
 * Activate a tab.
 * @param {*} tab Tab HTML element to activate.
 * @summary 
 * Removes .active class from all tabs and contents.
 * Then sets .active class to tab and asspcoated content 
 * using parameter attribute data-tab-id value.
 * @returns 
 */
function activateTab(tab) {
    if(tab.classList.contains('active'))
        return;

    tab.classList.add('active');
    
    Array.from(tab.parentNode.children)
        .filter(child => child !== tab && child.classList.contains('tab'))
        .forEach(tab => tab.classList.remove('active'));

    let contentContainer = tab.parentNode.parentNode.getElementsByClassName('content-container')[0];

    let contents = Array.from(contentContainer.children)
        .filter(child => child.classList.contains('content'));

    contents.forEach(content => {
        content.classList.remove('active');
    });

    contents.find(t => t.dataset.tabId == tab.dataset.tabId)
        .classList.add('active');
}

/**
 * Position the tab indicator under the specified tab.
 * @param {*} indicator Indicator HTML element to position.
 * @param {*} tabWidth Tab width.
 * @param {*} tabId Tab ID under which to position the tab indicator.
 */
function positionInditicator(indicator, tabWidth, tabId) {
    indicator.style.left = `${tabWidth * (tabId - 1)}%`; 
}
